import './App.css';
import { useState } from 'react';

const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5/weather';
const WEATHER_API_KEY = process.env.REACT_APP_OPENWEATHER_API_KEY;

function App() {
  const [query, setQuery] = useState('');
  const [weather, setWeather] = useState({
    loading: false,
    data: {},
    error: '',
  });

  const toDate = () => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];

    const currentDate = new Date();
    return `${days[currentDate.getDay()]} ${currentDate.getDate()} ${months[currentDate.getMonth()]}`;
  };

  const search = async (event) => {
    event.preventDefault();

    const city = query.trim();
    if (!city) {
      setWeather({ data: {}, loading: false, error: 'Please enter a city name.' });
      return;
    }

    if (!WEATHER_API_KEY) {
      setWeather({
        data: {},
        loading: false,
        error: 'Missing OpenWeather API key. Add REACT_APP_OPENWEATHER_API_KEY to .env.local.',
      });
      return;
    }

    setWeather({ data: {}, loading: true, error: '' });

    try {
      const params = new URLSearchParams({
        q: city,
        units: 'metric',
        appid: WEATHER_API_KEY,
      });
      const response = await fetch(`${WEATHER_API_URL}?${params.toString()}`);

      if (!response.ok) {
        throw new Error(response.status === 404 ? 'not-found' : 'request-failed');
      }

      const data = await response.json();
      setWeather({ data, loading: false, error: '' });
      setQuery('');
    } catch (error) {
      const message =
        error.message === 'not-found'
          ? 'Sorry, city not found. Please try again.'
          : 'Unable to fetch weather right now. Please try again later.';

      setWeather({ data: {}, loading: false, error: message });
    }
  };

  return (
    <div className="App">
      <h1>Weather App with React JS</h1>

      <form className="search-bar" onSubmit={search}>
        <input
          type="text"
          className="city-search"
          placeholder="Search city"
          name="query"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          autoComplete="off"
          aria-label="Search city"
        />
        <button type="submit">Search</button>
      </form>

      {weather.loading && <h4>Loading...</h4>}

      {weather.error && (
        <span className="error-message" role="alert">
          {weather.error}
        </span>
      )}

      {weather.data?.main && (
        <div className="weather-result">
          <div className="city-name">
            <h2>
              {weather.data.name}, <span>{weather.data.sys.country}</span>
            </h2>
          </div>
          <div className="date">
            <span>{toDate()}</span>
          </div>
          <div className="icon-temp">
            <img
              src={`https://openweathermap.org/img/wn/${weather.data.weather[0].icon}@2x.png`}
              alt={weather.data.weather[0].description}
            />
            {Math.round(weather.data.main.temp)}
            <sup className="deg">&deg;C</sup>
          </div>
          <div className="des-wind">
            <p>{weather.data.weather[0].description.toUpperCase()}</p>
            <p>Wind speed: {weather.data.wind.speed} m/s</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
